import "./add.css"
import { useState, useEffect, useContext } from "react";
import { Form, Input, Button, message } from "antd";
import { useNavigate, useParams } from 'react-router-dom';
import { Item, ItemService } from '../../services/Item';
import TableForm from "./tableForm";
import QuillEditor from "../quillEditor/quillEditor";
import { Tool, ToolService } from "../../services/Tool";
import { ItemsContext } from "../../layout/itemContext/itemContext";


function ItemEdit() {

    const navigate = useNavigate();
    const params = useParams();
    const [tools, setTools] = useState<Tool[]>([]);
    const [form] = Form.useForm();
    const [item, setItem] = useState<Item>();
    const [initValues, setInitValues] = useState({})
    const { getTitles } = useContext(ItemsContext);
    
    useEffect( () => {
        const getTools = async () => {
            const {data} = await ToolService.getAll(params.country)
            setTools(data)
        }
        getTools();
        
    }, [params.country])

    useEffect(() => {
        if (params.id) {
            getItem(params.id)
        } else {
            setItem(undefined);

        }

    }, [params.id])

    useEffect(() => {
        form.resetFields()
    }, [initValues])

    const getItem = async (_id: string) => {
        const { data } = await ItemService.getById(_id);
        setItem(data);
        setInitValues(data)
    }


    const save = async (values: any) => {
        values._id = item?._id;
        await ItemService.update({ ...values, parent: item?.parent })
        message.success('Item successfully updated!')
        await getTitles();
        navigate(`/${item?.country}/${item?._id}`, { replace: true })
    };
   
    return (
        <div className='wrapper'>
            <h1>Edit Item</h1>
            {item?.itemType === 'content' && <QuillEditor item={item}/>}
            {item?.itemType ==='table' &&  <Form
                name="basic"
                form={form}
                initialValues={initValues}
                onFinish={save}
                scrollToFirstError={true}
                className='add-item'
                layout="vertical"
            >
                <Form.Item name="title" label="Title" >
                  <Input/>
                </Form.Item>
                <TableForm name='tablePlanning' title='Planning and Preparatory stage' tools={tools}/>
                <TableForm name='tableBids' title='Bids Solicitation' tools={tools}/>
                <TableForm name='tableEvaluation' title='Evaluation' tools={tools}/>
                <TableForm name='tableCommitteeReview' title='Committee Review' tools={tools}/>
                <TableForm name='tableContractAward' title='Contract Award' tools={tools}/>
                <TableForm name='tableContractManagement' title='Contract Management' tools={tools}/>
                
                <Form.Item>
                    <Button type="primary" htmlType="submit" className="form-submit-button">
                        SAVE
                    </Button>
                </Form.Item>
            </Form>}
        </div>

    );
}

export default ItemEdit;